var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export const AnalyticsContext = React.createContext({});
const AnalyticsProvider = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const parentContext = React.useContext(AnalyticsContext);
    const contextValue = Object.assign(Object.assign({}, parentContext), rest);
    return (React.createElement(AnalyticsContext.Provider, { value: contextValue }, children));
};
export default AnalyticsProvider;
export const useAnalytics = () => {
    const context = React.useContext(AnalyticsContext);
    return {
        push: (id, elementId, interactionTypeArg, trigger) => {
            if (context.onPush) {
                const event = (trigger === null || trigger === void 0 ? void 0 : trigger.event) || context.event;
                const page = (trigger === null || trigger === void 0 ? void 0 : trigger.page) || context.page;
                const group = (trigger === null || trigger === void 0 ? void 0 : trigger.group) || context.group;
                const elementType = (trigger === null || trigger === void 0 ? void 0 : trigger.elementType) || context.elementType;
                const interactionType = (trigger === null || trigger === void 0 ? void 0 : trigger.interactionType) || context.interactionType || interactionTypeArg;
                const conversion = (trigger === null || trigger === void 0 ? void 0 : trigger.conversion) || context.conversion;
                const conversionType = (trigger === null || trigger === void 0 ? void 0 : trigger.conversionType) || context.conversionType;
                if (event && page && group) {
                    context.onPush({
                        event,
                        page,
                        group,
                        id,
                        elementType,
                        elementId,
                        interactionType,
                        conversion,
                        conversionType,
                    });
                }
            }
        },
    };
};
